import { css } from "emotion";

export const activeColor1 = css`
    background-color: #b43034;
    border-color: #b43034;
    border-left-color: #b43034;
`;

export const activeColor2 = css`
    background-color: #de9500;
    border-color: #de9500;
    border-left-color: #de9500;
`;
export const activeColor3 = css`
    background-color: #ecdb00;
    border-color: #ecdb00;
    border-left-color: #ecdb00;
`;
export const activeColor4 = css`
    background-color: #8ac100;
    border-color: #8ac100;
    border-left-color: #8ac100;
`;
export const activeColor5 = css`
    background-color: #009b00;
    border-color: #009b00;
    border-left-color: #009b00;
`;

export const starContainer = css`
    background-color: #ededed;
    width: 38px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 36px;
    text-shadow: 0 -0.05em #b9b9b9;
    color: #fff;
    border-style: solid;
    border-width: 1px;
    border-color: #ccc #ccc #aaa #eee;
    border-top-color: rgb(204, 204, 204);
    border-right-color: rgb(204, 204, 204);
    border-bottom-color: rgb(170, 170, 170);
    border-left-color: rgb(238, 238, 238);
    background-image: -webkit-linear-gradient(top,rgba(255,255,255,0) 0,rgba(255,255,255,.2) 100%);
`;

export const firstStarContainer = css`
    border-left-color: rgb(204, 204, 204);
    border-bottom-left-radius: 3px;
    border-top-left-radius: 3px;
`;

export const lastStarContainer = css`
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
`;